import { Component } from "@angular/core";

@Component({
    selector: "vds-breadcrumbs",
    templateUrl: "./breadcrumbs.component.html",
    styleUrl: "./breadcrumbs.component.css",
    imports: []
})
export class VdsBreadcrumbsComponent {}
